$(function () {
    $('[data-toggle="tooltip"]').tooltip({});
    $('[data-tt="tt"]').tooltip({});
    $('[data-toggle="popover"]').popover({trigger: "hover"});
    $('[data-s2="true"]').select2({ theme: "bootstrap" });
    $('table.dt').each(function () { $(this).DataTable(); });

    $("[role='tablist']").each(function() {
        if ($(this).find('.active').length === 0) {
            $(this).find('[data-toggle="tab"]').first().tab('show');
        }
    });

    $('.date-container').each(function() {
        $(this).datepicker();
    });
});

window.toggleDivs = function(divA, divB) {
    $(divA).toggleClass('hidden');
    $(divB).toggleClass('hidden');
}

/*
 * pad strings with zeroes
 */

window.pad = function (str, max) {
    str = str.toString();
    return str.length < max ? pad("0" + str, max) : str;
}

window.trim = function(str) {
    return str.replace(/^\s+|\s+$/g, '');
}

window.empty = function(mixedVar) {
    //  discuss at: http://locutus.io/php/empty/

    // let undef;
    let key;
    let i;
    let len;
    const emptyValues = [undefined, null, false, 0, '', '0'];

    for (i = 0, len = emptyValues.length; i < len; i++) {
        if (mixedVar === emptyValues[i]) {
            return true
        }
    }

    if (typeof mixedVar === 'object') {
        for (key in mixedVar) {
            if (mixedVar.hasOwnProperty(key)) {
                return false
            }
        }
        return true
    }

    return false
};
